import React from "react";
import { connect } from "react-redux";
import axios from "../../../axios-config.js";
import withRouter from "../../../withRouter.js";

class PasswordResetForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmedPassword: "",
      token: props.token,
      tokenValid: true,
      checkingToken: true,
      errors: [],
      changeSuccess: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const token = this.props.token;

    if (!token) {
      this.setState({ tokenValid: false, checkingToken: false });
      return;
    }

    // Check if token is valid
    axios
      .post("/resetpassword", {
        token: token,
      })
      .then((response) => {
        this.setState({ token: token, checkingToken: false });
      })
      .catch((error) => {
        this.setState({ tokenValid: false, checkingToken: false });
      });
  }

  handleSubmit() {
    const newErrors = [];

    if (this.state.newPassword !== this.state.confirmedPassword) {
      newErrors.push("Passwords Do Not Match");
      this.setState({ errors: newErrors });
      return;
    }

    if (this.state.newPassword.length < 10) {
      newErrors.push(`Password must contain at least 10 characters`);
      newErrors.push(`Your entered password contains ${this.state.newPassword.length} characters`);
      this.setState({ errors: newErrors });
      return;
    }

    axios
      .post("/resetpassword", {
        token: this.state.token,
        password: this.state.newPassword,
      })
      .then((response) => {
        this.setState({
          newPassword: "",
          confirmedPassword: "",
          changeSuccess: true,
          errors: [],
        });
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || "An error occurred while resetting your password";
        newErrors.push(errorMessage);
        this.setState({ errors: newErrors });
      });
  }

  render() {
    const handleNewPassword = (e) => {
      this.setState({ newPassword: e.target.value });
    };

    const handleConfirmedPassword = (e) => {
      this.setState({ confirmedPassword: e.target.value });
    };

    const handleClose = () => {
      window.location = "/";
    };

    if (this.state.checkingToken) {
      return (
        <div className="passwordResetContainer">
          <div className="passwordForm">
            <div className="passwordFormTitle">Inventum3D</div>
            <div style={{ textAlign: "center", fontSize: "18px", marginTop: "10px" }}>Checking Token Validity...</div>
          </div>
        </div>
      );
    }

    if (!this.state.tokenValid) {
      return (
        <div className="passwordResetContainer">
          <div className="passwordForm">
            <div className="passwordFormTitle">Inventum3D</div>
            <div className="tokenExpiredWarning">Reset Token is Invalid or has Expired</div>
            <div style={{ fontSize: "16px", textAlign: "center", margin: "10px 0" }}>Please request a new password reset link.</div>
            <div className="passwordFormSubmit" onClick={handleClose}>
              Go to Homepage
            </div>
          </div>
        </div>
      );
    }

    if (this.state.changeSuccess) {
      return (
        <div className="passwordResetContainer">
          <div className="passwordForm">
            <div className="passwordFormTitle">Inventum3D</div>
            <div
              style={{
                textAlign: "center",
                backgroundColor: "#28a745",
                padding: "15px",
                marginBottom: "15px",
                borderRadius: "4px",
              }}>
              <strong>Password Changed Successfully!</strong>
              <div style={{ marginTop: "8px", fontSize: "16px" }}>You can now log in with your new password.</div>
            </div>
            <div className="passwordFormSubmit" onClick={handleClose}>
              Go to Login
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="passwordResetContainer">
        <div className="passwordForm">
          <div className="passwordFormTitle">Reset Your Password</div>

          <input onChange={handleNewPassword} value={this.state.newPassword} placeholder="New Password" type="password" />

          <input
            onChange={handleConfirmedPassword}
            value={this.state.confirmedPassword}
            placeholder="Confirm New Password"
            type="password"
          />

          {this.state.errors.length > 0 && (
            <div className="errorsBoxPassword">
              {this.state.errors.map((error, index) => (
                <div key={index}>{error}</div>
              ))}
            </div>
          )}

          <div className="passwordFormSubmit" onClick={this.handleSubmit}>
            Reset Password
          </div>

          <div
            style={{
              marginTop: "15px",
              fontSize: "14px",
              textAlign: "center",
              opacity: "0.8",
            }}>
            Password must be at least 10 characters long
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

const PasswordResetContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordResetForm));

export default PasswordResetContainer;
